/**
 * drawer-menu-item.js
 */

import React from 'react';
import { alpha, useMediaQuery, ListItem, ListItemIcon, ListItemText, Divider } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Link } from 'react-router-dom';
import Icon from 'components/icon';


const useStyles = makeStyles(theme => ({
  menuItem: {
    position: 'relative',
    minHeight: theme.spacing(5),
    borderRadius: 3,
    '& .MuiListItemText-root': {
      whiteSpace: 'nowrap',
      // marginRight: theme.spacing(2),
    },
    '& .MuiListItemText-primary': {
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    '& .MuiListItemText-multiline': {
      marginTop: 0,
      marginBottom: 0
    },
    [theme.breakpoints.up('md')]: {
      padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
      paddingRight: theme.spacing(2)
    },
    '.drawer-menu &': {
      borderRadius: '3px 0 0 3px',
    },
  },
  menuItemIcon: {
    minWidth: theme.spacing(5)
  },
  labelEnd: {
    marginRight: theme.spacing(1),
  },
  navForward: {
    color: theme.palette.grey.colors[6],
    fontSize: theme.typography.sizes[2],
    marginLeft: theme.spacing(1),
  },
  active: {
    backgroundColor: theme.palette.grey.colors[7],
    '&:hover': {
      backgroundColor: theme.palette.grey.colors[7]
    },
    '.drawer-menu &': { 
      filter: `drop-shadow(0.5px 1px 0.5px ${alpha(theme.palette.grey.colors[2], 0.2)})`,
      '&::before': {
        content: '""',
        position: 'absolute',
        width: theme.size.menuDrawer.arrowWidth,
        left: '100%',
        top: '0',
        height: '50%',
        background: `linear-gradient(to right top, ${theme.palette.grey.colors[7]} 48%, transparent 52%)`,
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        width: theme.size.menuDrawer.arrowWidth,
        left: '100%',
        top: '50%',
        height: '50%',
        background: `linear-gradient(to right bottom, ${theme.palette.grey.colors[7]} 48%, transparent 52%)`,
      },
    },
  },
  highlighted: {
    '& .MuiTypography-root': {
      fontWeight: 'bold'
    } 
  }
}));


export default function DrawerMenuItem(props) {
  const {
    id,
    iconName,
    icon,
    label,
    labelSub,
    labelEnd,
    to,
    isActive,
    isHighlighted,
    disabled,
    className,
    hideChevron,
    noBGHover
  } = props;
  const classes = useStyles();
  const mobileLayout = useMediaQuery(theme => theme.breakpoints.down('sm_md'));

  
  return (
    <>
      <ListItem
        button={Boolean(!noBGHover && to)}
        aria-label={`drawer-menu-item-${id}`}
        className={`drawer-menu-item ${classes.menuItem} ${className || ''}`
          + ` ${isActive ? `${classes.active} active` : ''}`
          + ` ${isHighlighted ? classes.highlighted : ''}`}
        classes={{ container: classes.root }}
        disabled={disabled}
      >
        {!disabled && Boolean(to) &&
        <Link
          to={to}
          className='absolute-fill'
        />}

        {(icon || iconName) &&
        <ListItemIcon className={classes.menuItemIcon}>
          {iconName && <Icon type={iconName} />}
          {icon}
        </ListItemIcon>}

        <ListItemText primary={label} secondary={labelSub} />
        
        {labelEnd &&
        <div className={classes.labelEnd}>{labelEnd}</div>}

        {!hideChevron && mobileLayout && !disabled &&
        <Icon
          type='nav-forward'
          fontSize="small"
          className={classes.navForward}
        />}
      </ListItem>
      {mobileLayout && <Divider />}
    </>
  );
}